import { useIsCreateDialogMinimised } from 'components/create-dialog/CreateDialogContext';
import { useIsNewDesign } from 'components/tables/list-table/filter-bar/useIsNewDesign';
import { useSelector } from 'store';
import { selectIsRibbonOnScreen } from 'store/reducers/exports';

/**
 * Whether a page keeps room under its last row for what sits in the window's bottom row: classic's floating
 * buttons, an export ribbon in either design, or the new design's minimised create dialog.
 */
export function useReserveBottomRow() {
    const isNew = useIsNewDesign();
    const isRibbonOnScreen = useSelector(selectIsRibbonOnScreen);
    const isCreateDialogMinimised = useIsCreateDialogMinimised();
    return !isNew || isRibbonOnScreen || isCreateDialogMinimised;
}
